import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

export const CheckboxIcon = createSvgIcon(
  <>
    <rect
      width="22"
      height="22"
      rx="2"
      ry="2"
      x="1"
      y="1"
      strokeWidth="2"
      stroke="currentColor"
      fill="transparent"
      strokeLinejoin="round"
    />
  </>,
  "CheckboxIcon"
);
